import { type FundraiserType } from "../types";

const REPORT_FORM_URL = "https://forms.cancerresearchuk.org/250432902866963";

// This works with uuid or slug
export const reportFormUrl = ({
  issueUrl,
  fundraiser,
}: {
  issueUrl: string;
  fundraiser?: FundraiserType | null;
}): string =>
  `${REPORT_FORM_URL}/?url=${issueUrl || ""}&email=${fundraiser?.emailAddress || ""}&firstName=${fundraiser?.forename || ""}&lastName=${fundraiser?.surname || ""}`;

export default reportFormUrl;
